import { render, staticRenderFns } from "./whiteboard.vue?vue&type=template&id=1c4e4fc9&scoped=true&"
import script from "./whiteboard.vue?vue&type=script&lang=js&"
export * from "./whiteboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4e4fc9",
  null
  
)

export default component.exports